const $inject = ['$q', '$http', '$httpParamSerializer', 'moment','$location'];

const authService = function ($q, $http, $httpParamSerializer, moment,$location) {
  const service = {
    prevRoute: undefined,
    getUsername,
    login,
    logout,
    refresh,
    getOauth,
    clearOauth,
    getAccessToken,
    getRefreshToken,
    isAuthenticated,
    setBulkChangeAdmin,
    getIsBulkChangeAdmin,
    setCanUploadRegionalMobileContactDetails,
    getCanUploadRegionalMobileContactDetails,
    storeAuth,
    isAuthorized
  };

  let CLIENT_ID = '40cd37d4-267a-43ca-99d3-f5bd67b8e58d';

  function getUsername() {
    return service.getOauth().username;
  }

  function login(username, password) {
    let data = {
      client_id: CLIENT_ID,
      grant_type: 'password',
      username: username,
      password: password
    };

    let req = {
      method: 'POST',
      url: `${endPointUrl}/Token`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };

    return $http(req).then(function (data) {
      let oauth = data.data;
      oauth.expires_at = moment().add(oauth.expires_in, 's').format('x');
      oauth.username = username;

      service.storeAuth(oauth);
    });
  }
  

  function logout() {
    let deferred = $q.defer();
    if (auth0Config.Enabled) {
      $location.path('/logout');
    }else{
      service.clearOauth();
    } 
    deferred.resolve();

    return deferred.promise;
  }

  function refresh() {
    let data = {
      client_id: CLIENT_ID,
      grant_type: 'refresh_token',
      refresh_token: getRefreshToken()
    };

    let req = {
      method: 'POST',
      url: `${endPointUrl}/Token`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };

    return $http(req).then(function (data) {
      let oauth = {};
      oauth.refresh_token = data.refresh_token;
      oauth.access_token = data.access_token;

      service.storeAuth(oauth);
    });
  }
  
  function setBulkChangeAdmin(){
   
    let deferred = $q.defer();
    var oauth = getOauth();
    if(!oauth) {
      deferred.resolve();
      return deferred.promise;
    }
    let req = {
      method: 'POST',
      url: `${endPointUrl}/api/Upload/CanImportConfiguration`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      }
    };
     $http(req).then(function (data) {
      const bulkDataResponse = JSON.stringify(data.data)
      localStorage.setItem('CanImportConfiguration', bulkDataResponse);
      
      deferred.resolve(data.data);
      
    },(error,status)=>{
      
      console.log('error',error);
      if(error.status===401 || error.status===403){
        deferred.reject(error);
      }
    });
     return deferred.promise;
  }

  function getIsBulkChangeAdmin() {
    const data = JSON.parse(localStorage.getItem('CanImportConfiguration'));
    return data;
  }

  function setCanUploadRegionalMobileContactDetails(){
    let deferred = $q.defer();
    let req = {
      method: 'POST',
      url: `${endPointUrl}/api/Upload/CanUploadRegionalMobileContactDetails`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      }
    };

     $http(req).then(function (data) {
      localStorage.setItem('CanUploadRegionalMobileContactDetails', JSON.stringify(data.data));
      deferred.resolve(data.data);
    });
     return deferred.promise;
  }

  function getCanUploadRegionalMobileContactDetails() {
    return JSON.parse(localStorage.getItem('CanUploadRegionalMobileContactDetails'));
  }

  function storeAuth(oauth){
    if(!oauth.expires_at && oauth.expires_in){
      oauth.expires_at = moment().add(oauth.expires_in, 's').format('x');
    }
    
    localStorage.setItem('oauth', JSON.stringify(oauth));
      setBulkChangeAdmin();
      setCanUploadRegionalMobileContactDetails();
  }
  function getOauth() {
    return JSON.parse(localStorage.getItem('oauth'));
  }

  function clearOauth() {
    return localStorage.removeItem('oauth');
  }

  function getAccessToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.access_token : '';
  }

  function getRefreshToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.refresh_token : '';
  }

  function isAuthenticated() {
    var oauth = service.getOauth();
    return oauth && oauth.expires_at && oauth.expires_at > Date.now();
  }
  function isAuthorized() {
    let deferred = $q.defer();
    setBulkChangeAdmin().then(()=>{
      deferred.resolve(true);
   },(error)=>{
    deferred.resolve(false);
  });
  return deferred.promise;
  }

  return service;
};

authService.$inject = $inject;

export default authService;



// WEBPACK FOOTER //
// ./src/services/authService.js